import { useUpdateUserDetailMutation } from 'api/userApi';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ResponsiveDialog } from 'ui';
import UpdateUserName, { GetItemDetailsProps } from 'ui/components/UpdateUsernamePrompt';
import { isInIframe } from 'utils/proxyUtils';
import { getSelectedSiteCollaborateInfo, getSelectedSiteInfo } from '../../../store/siteInfoSlice';
import { getShowUpdateUserName, setShowUpdateUserName, setUpdateUserName } from '../../../store/userSlice';

export default function UpdateUsernameModal() {
    const dispatch = useDispatch();
    const itemDetails = useSelector(getSelectedSiteCollaborateInfo)
    const showUpdateUserName = useSelector(getShowUpdateUserName);
    const siteInfo = useSelector(getSelectedSiteInfo);
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [isEightChar, setIsEightChar] = useState(false);
    const [isNumAndCap, setIsNumAndCap] = useState(false);
    const [isSpecialChar, setIsSpecialChar] = useState(false);
    const [updateUserdetails, { isLoading: isUpdating }] = useUpdateUserDetailMutation();

    useEffect(() => {
        if (!isInIframe()) return;

        const handleMessage = (event: MessageEvent) => {
            if (event.data.type === 'NAME_PASSWORD_RESPONSE') {
                dispatch(setUpdateUserName(name))
                dispatch(setShowUpdateUserName(false))
            }
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, [name, dispatch]);

    const updateUserDetail = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();
        if (!name || !password) return
        const data = {
            name,
            new_password: password,
            new_password_confirmation: password,
            workspace_id: siteInfo?.workspace_id
        }
        if (isInIframe()) {
            try {
                window.parent.postMessage({
                    type: 'UPDATE_NAME_PASSWORD',
                    userData: data
                }, '*');
            } catch (error) {
                console.error("Error updating username and password", error)
            }
        } else {
            // Call the API to update user details
            try {
                await updateUserdetails(data).unwrap();
                dispatch(setUpdateUserName(name))
                dispatch(setShowUpdateUserName(false))
            } catch (error) {
                console.error("Error updating username and password", error)
            }
        }


    };
    const handleChangeName = (e: {
        target: HTMLInputElement; preventDefault: () => void;
    }) => {
        setName(e.target.value);
    };
    const handleChangeLoginPassword = (e: {
        target: HTMLInputElement; preventDefault: () => void;
    }) => {
        setPassword(e.target.value);
        if (e.target.value.length >= 8) {
            setIsEightChar(true);
        } else {
            setIsEightChar(false);
        }

        if (/\d/.test(e.target.value) && /[A-Z]/.test(e.target.value)) {
            setIsNumAndCap(true);
        } else {
            setIsNumAndCap(false);
        }

        if (/[!@#$%^&*(),.?":{}|<>/[\]]/.test(e.target.value)) {
            setIsSpecialChar(true);
        } else {
            setIsSpecialChar(false);
        }
    };
    const handleChange = (bool: boolean) => {
        dispatch(setShowUpdateUserName(bool));
    };

    const collabMode = false
    const selectedGraphic = null;
    const logoSrc = siteInfo?.setting?.whiteLabel.logo ?? "";

    return (
        <ResponsiveDialog open={showUpdateUserName} onOpenChange={handleChange}>
            <UpdateUserName
                name={name}
                password={password}
                handleChangeName={handleChangeName}
                handleChangeLoginPassword={handleChangeLoginPassword}
                isUpdating={isUpdating}
                updateUserDetail={updateUserDetail}
                collabMode={collabMode}
                imageGraphicItem={selectedGraphic}
                itemDetails={itemDetails?.result || {} as GetItemDetailsProps}
                logoSrc={logoSrc}
                isEightChar={isEightChar}
                isNumAndCap={isNumAndCap}
                isSpecialChar={isSpecialChar}
                container={document.getElementById('root-atarim')?.shadowRoot?.getElementById('app-wrapper')}
            />
        </ResponsiveDialog>
    );
}
